import tempMeeApi from '../apis/tempMee';

export const getChallenges = async ({ status, limit, page } = {}) =>
  tempMeeApi.get('metrics-service/admin/professional-loyalty/challenges', {
    params: {
      status,
      limit: limit || 20,
      page,
    },
  });

export const postChallenge = async (data = {}) =>
  tempMeeApi.post('metrics-service/admin/professional-loyalty/challenges', data);

export const cancelChallenge = async (id) =>
  tempMeeApi.delete(`metrics-service/admin/professional-loyalty/challenges/${id}`);

export const getProfChallenges = async ({ profId, status, limit, page } = {}) =>
  tempMeeApi.get(`metrics-service/admin/professional-loyalty/${profId}/challenges`, {
    params: {
      status,
      limit: limit || 20,
      page,
    },
  });
